export default "__VITE_ASSET__ksY4Iore__"